'use strict';

/*
 * Port of AS3 AdvDate.as class.
 * Delegate calls to contained instance of Date.
 */

var AdvDate = (function() {

    /*
     * accepts dates of the form 'dd/mm/yyyy' as one param or yyyy,mm,dd as seperate number params
     * If you pass a string, AdvDate('01/01/2007') = 1 Jan 2007
     * If you pass a JavaScript Date, AdvDate(2007, 0, 1) = 1 Jan 2007.
     * ... because JavaScript months are in the range 0-11, rather than 1-12 that we normally think of.
     */
    function AdvDate() {

        this.date = null;

        var day   = null;
        var month = null;
        var year  = null;

        if (arguments.length === 0) {
            this.date = new Date();
        } else if (arguments.length === 1 && typeof(arguments[0]) === 'string') {
            var stringArg   = arguments[0];
            var stringParts = this.splitStringDate(stringArg);

            day   = stringParts[0];
            month = stringParts[1];
            year  = stringParts[2];

            this.date = new Date(year, month, day);
        } else if (arguments.length === 1 && typeof(arguments[0]) === 'number') {
            this.date = new Date(arguments[0]);
        } else if (arguments.length === 1 && typeof(arguments[0]) === 'object' && (arguments[0] instanceof AdvDate || arguments[0] instanceof Date)) {
            this.date = new Date(arguments[0].getTime());
        } else if (arguments.length === 3 && (typeof(arguments[0]) === 'number' && typeof(arguments[1]) === 'number' && typeof(arguments[2]) === 'number')) {
            year  = parseInt(arguments[0]);
            month = parseInt(arguments[1]);
            day   = parseInt(arguments[2]);

            this.date = new Date(year, month, day);
        } else {
            throw new Error('Unsupported number of arguments');
        }        
    }

    //define constants, accessible without needing to instantiate AdvDate
    AdvDate.MILLISECONDS_IN_YEAR = 31536000000;
    AdvDate.DAYS_IN_YEAR = 365;
    AdvDate.WEEKS_IN_YEAR = 52;
    AdvDate.MONTHS_IN_YEAR = 12;

    AdvDate.HOURS_IN_DAY = 24;
    AdvDate.MINUTES_IN_HOUR = 60;
    AdvDate.SECONDS_IN_MINUTE = 60;
    AdvDate.MILLIS_IN_SECOND = 1000;

    AdvDate.prototype.getDate = function() {
        return this.date.getDate();
    };

    AdvDate.prototype.getDay = function() {
        return this.date.getDay();
    };

    AdvDate.prototype.getFullYear = function() {
        return this.date.getFullYear();
    };

    AdvDate.prototype.getHours = function() {
        return this.date.getHours();
    };

    AdvDate.prototype.getMilliseconds = function() {
        return this.date.getMilliseconds();
    };

    AdvDate.prototype.getMinutes = function() {
        return this.date.getMinutes();
    };

    AdvDate.prototype.getMonth = function() {
        return this.date.getMonth();
    };

    AdvDate.prototype.getSeconds = function() {
        return this.date.getSeconds();
    };

    AdvDate.prototype.getTime = function() {
        return this.date.getTime();
    };

    AdvDate.prototype.getTimezoneOffset = function() {
        return this.date.getTimezoneOffset();
    };

    AdvDate.prototype.setDate = function(date) {
        this.date.setDate(date);
    };

    AdvDate.prototype.setFullYear = function(year) {
        this.date.setFullYear(year);
    };

    AdvDate.prototype.setHours = function(hours) {
        this.date.setHours(hours);
    };

    AdvDate.prototype.setMilliseconds = function(milliseconds) {
        this.date.setMilliseconds(milliseconds);
    };

    AdvDate.prototype.setMinutes = function(minutes) {
        this.date.setMinutes(minutes);
    };

    AdvDate.prototype.setMonth = function(month) {
        this.date.setMonth(month);
    };

    AdvDate.prototype.setSeconds = function(seconds) {
        this.date.setSeconds(seconds);
    };

    AdvDate.prototype.setTime = function(time) {
        this.date.setTime(time);
    };

    /*
     * This returns a copy, not a reference to our underlying Date object, which might cause grief if exposed to changes.
     */
    AdvDate.prototype.toDate = function() {
        return new Date(this.getTime());
    };

    /*
     * Amend Date's toString to be less verbose and more sensible.
     */
    AdvDate.prototype.toString = function() {
        var date  = (this.getDate() < 10) ? '0' + this.getDate() : '' + this.getDate();
        var month = ((this.getMonth() + 1) < 10) ? '0' + (this.getMonth() + 1) : '' + (this.getMonth() + 1);
        return date + '/' + month + '/' + this.getFullYear();
    };

    /*
     * Alias for toString().
     */
    AdvDate.prototype.toShortDateString = function() {
        return this.toString();
    };

    /*
     * WARN: not the same implementation as date.js - use with caution!
     */
    AdvDate.parse = function(dateString) {
        return new AdvDate(dateString);
    };

    /*
     * Return the two letter Month postfix
     */
    AdvDate.prototype.dayPostfix = function() {
        switch (this.date.getDate()) {
            case 1:
            case 21:
            case 31:
                return 'st';
            case 2:
            case 22:
                return 'nd';
            case 3:
            case 23:
                return 'rd';
            default:
                return 'th';
        }
    };

    /*
     * Return month as full String
     */
    AdvDate.prototype.monthString = function() {
        return AdvDate.stringMonthFromNumber(this.date.getMonth() + 1);        
    };

    /*
     * the number of decimal years between date and this
     * equivalent of compareDateObjects(date,this)
     */
    AdvDate.prototype.minus = function(date) {
        return AdvDate.compareAdvDateObjects(date, this);
    };

    /*
     * @param yearShift the time shift to add on in years and decimal months/days
     */
    AdvDate.prototype.plus = function(yearShift) {
        var years      = yearShift + this.getFullYear();
        var wholeYears = Math.floor(years);
        var resultYears = wholeYears;

        //remember months run 0-11!
        var months        = this.getMonth() + (years - wholeYears) * AdvDate.MONTHS_IN_YEAR;
        var wholeMonths   = Math.floor(months);
        var decimalMonths = months;
        var resultMonths   = wholeMonths;

        while (resultMonths > (AdvDate.MONTHS_IN_YEAR - 1)) { //-1 as 11 is december
            resultMonths   -= AdvDate.MONTHS_IN_YEAR;
            decimalMonths  -= AdvDate.MONTHS_IN_YEAR;
            resultYears++;
        }

        //WARNING: using average days in month will introduce small error here
        var days        = this.getDate() + (decimalMonths - resultMonths) * (AdvDate.DAYS_IN_YEAR / AdvDate.MONTHS_IN_YEAR);
        var wholeDays   = Math.floor(days);
        var decimalDays = days;
        var resultdays   = wholeDays;

        while (resultdays > AdvDate.daysInMonth(resultMonths + 1, resultYears)) {
            resultdays   -= AdvDate.daysInMonth(resultMonths + 1, resultYears);
            decimalDays -= AdvDate.daysInMonth(resultMonths + 1, resultYears);

            resultMonths++;
            resultMonths = resultMonths % 12;
        }

        //now we're left day part which is generally insignificant in pensions calcs

        var resultDate = new AdvDate(resultYears, resultMonths, resultdays);

        return resultDate;
    };

    AdvDate.prototype.before = function(date) {
        return AdvDate.compareAdvDateObjects(this, date) > 0;
    };

    AdvDate.prototype.after = function(date) {
        return AdvDate.compareAdvDateObjects(this, date) < 0;
    };

    AdvDate.prototype.equals = function(date) {
        return date.getTime() === this.getTime();
    };

    AdvDate.prototype.beforeOrOn = function(date) {
        return AdvDate.compareAdvDateObjects(this, date) >= 0;
    };

    AdvDate.prototype.afterOrOn = function(date) {
        return AdvDate.compareAdvDateObjects(this, date) <= 0;
    };

    /*
     * TODO: consider how to add to culture. This assumes UK.
     */
    AdvDate.prototype.financialYear = function() {
        if ((this.getMonth() + 1) < 4 || ((this.getMonth() + 1) == 4 && this.getDate() < 6)) {
            return this.getFullYear() - 1;
        } else {
            return this.getFullYear();
        }
    };

    AdvDate.prototype.clone = function() {
        return new AdvDate(this.getTime());
    };

    /*
     * @return a pointer to the earlier of the two dates
     * If both dates are equal then returns date1
     */
    AdvDate.earlierOf = function(date1, date2) {
        if (date1.beforeOrOn(date2)) {
            return date1;
        } else {
            return date2;
        }
    };

    /*
     * @return a pointer to the later of the two dates
     * If both dates are equal then returns date1
     */
    AdvDate.laterOf = function(date1, date2) {
        if (date1.afterOrOn(date2)) {
            return date1;
        } else {
            return date2;
        }
    };

    /*
     * returns a month number indexed from 1 from the 3 letter month abbreviation
     */
    AdvDate.stringMonthToNumber = function(stringMonth) {
        var monthString = stringMonth.toLowerCase().substring(0, 3);
        switch (monthString) {
            case 'jan':
                return 1;
            case 'feb':
                return 2;
            case 'mar':
                return 3;
            case 'apr':
                return 4;
            case 'may':
                return 5;
            case 'jun':
                return 6;
            case 'jul':
                return 7;
            case 'aug':
                return 8;
            case 'sep':
                return 9;
            case 'oct':
                return 10;
            case 'nov':
                return 11;
            case 'dec':
                return 12;
            default:
                return Number.NaN;
        }
    };

    AdvDate.stringMonthFromNumber = function(monthNumber) {
        switch (monthNumber) {
            case 1:
                return 'January';
            case 2:
                return 'February';
            case 3:
                return 'March';
            case 4:
                return 'April';
            case 5:
                return 'May';
            case 6:
                return 'June';
            case 7:
                return 'July';
            case 8:
                return 'August';
            case 9:
                return 'September';
            case 10:
                return 'October';
            case 11:
                return 'November';
            case 12:
                return 'December';
            default:
                return '';
        }
    };

    /*
     * @return the normal number of days in the month of the specified number, assumming not a leap year
     * WARNING: months here referenced 1-12 rather than 0-11
     * if month is invalid returns NaN
     */
    AdvDate.daysInMonth = function(month, year) {
        switch (month) {
                //30 days hath September,
            case 9:
                //April,
            case 4:
                //June,
            case 6:
                //and November.
            case 11:
                return 30;
                //all the rest have 31
            case 1:
            case 3:
            case 5:
            case 7:
            case 8:
            case 10:
            case 12:
                return 31;
                //except for February all alone,
            case 2:
                //it has 28 each year, but 29 each leap year
                return AdvDate.isLeapYear(year) ? 29 : 28;
                //and abstract not real negative months etc which can't possibly have any days in them
            default:
                return Number.NaN;
        }
    };

    AdvDate.isLeapYear = function(year) {
        return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
    };

    /*
     * @return the total number of days (in a non leap year) from the 1st of January
     */
    AdvDate.daysToDayOfMonth = function(day, month) {
        var days = day;
        for (var i = 1; i < month; i++) {
            days += AdvDate.daysInMonth(i);
        }
        return days;
    };

    /*
     * @return the difference between two dates in years, disregarding leap year corrections
     */
    AdvDate.compareDates = function(startDay, startMonth, startYear, endDay, endMonth, endYear) {
        return AdvDate.daysToDayOfMonth(endDay, endMonth) / AdvDate.DAYS_IN_YEAR + endYear - AdvDate.daysToDayOfMonth(startDay, startMonth) / AdvDate.DAYS_IN_YEAR - startYear;
    };

    /*
     * @return the difference between two dates in years, disregarding leap year corrections
     */
    AdvDate.compareDateObjects = function(startDate, endDate) {
        return AdvDate.compareDates(startDate.getDate(), startDate.getMonth() + 1, startDate.getFullYear(), endDate.getDate(), endDate.getMonth() + 1, endDate.getFullYear());
    };

    /*
     * @return the difference between two dates in years, disregarding leap year corrections
     */
    AdvDate.compareAdvDateObjects = function(startDate, endDate) {
        return AdvDate.compareDateObjects(startDate, endDate);
    };

    /*
     * @return the number of whole months between the two dates,
     * -1 if the start date is later than the end date, or either date is null
     */
    AdvDate.monthsBetween = function(startDate, endDate) {
        if (startDate !== null && endDate !== null && AdvDate.compareAdvDateObjects(startDate, endDate) >= 0) {
            var months = (endDate.getFullYear() - startDate.getFullYear()) * AdvDate.MONTHS_IN_YEAR + endDate.getMonth() - startDate.getMonth();
            if (startDate.getDate() > endDate.getDate()) {
                return months - 1;
            } else {
                return months;
            }
        } else {
            return -1;
        }
    };

    /*
     * @param period a time period, decimal period
     * @return the period rounded to the nearest month
     */
    AdvDate.prototype.roundMonths = function(period) {
        //this can be achieveed by rounding to nearest 1/12
        return Math.round(period * AdvDate.MONTHS_IN_YEAR) / AdvDate.MONTHS_IN_YEAR;
    };

    /*
     * @param period a time period, decimal period
     * @return the period rounded down to the next whole month, ie the number of complete months within the period
     */
    AdvDate.prototype.floorMonths = function(period) {
        //this can be achieved by flooring to next 1/12
        return Math.floor(period * AdvDate.MONTHS_IN_YEAR) / AdvDate.MONTHS_IN_YEAR;
    };

    AdvDate.prototype.validStringDate = function(date) {
        var parts = this.splitStringDate(date);

        if (isNaN(parts[0]) || isNaN(parts[1]) || isNaN(parts[2])) {
            return false;
        }

        if (parts[1] < 1 || parts[1] > AdvDate.MONTHS_IN_YEAR) {
            return false;
        } else if (parts[0] < 1 || parts[0] > AdvDate.daysInMonth(parts[1] + 1)) {
            return false;
        }

        return true;
    };

    /*
     * Today's date, hours/minutes/second/millis all 0
     */
    AdvDate.today = function() {
        var date = AdvDate.now();

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date;
    };

    /*
     * Today's date, time now.
     */
    AdvDate.now = function() {
        return new AdvDate();
    };

    AdvDate.prototype.splitStringDate = function(date) {
        var parts = date.split('/');
        return [parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10)];
    };

    AdvDate.prototype.getDateWithMonthString = function() {
        return this.date.getDate() + ' ' + this.monthString() + ' ' + this.date.getFullYear();
    };

    //NOTE: this approach matches Excel date subtraction - e.g. date1 - date2
    // IMPORTANT: Excel uses 365.25 days per year, to match Excel pass millisecondsInYear as 31557600000
    AdvDate.prototype.fastMinus = function(dateParam, millisecondsInYear) {
        millisecondsInYear = millisecondsInYear || AdvDate.MILLISECONDS_IN_YEAR;
        return (this.date.valueOf() - dateParam.date.valueOf()) / millisecondsInYear;
    };

    AdvDate.prototype.fastPlus = function(yearsParam, millisecondsInYear) {
        millisecondsInYear = millisecondsInYear || AdvDate.MILLISECONDS_IN_YEAR;
        return new AdvDate(this.date.valueOf() + (millisecondsInYear * yearsParam));
    };

    AdvDate.prototype.addMonths = function(months) {
        var dayOfMonth  = this.getDate();
        this.setDate(1);
        this.setMonth(this.getMonth() + months);
        this.setDate(Math.min(dayOfMonth, AdvDate.daysInMonth(this.getMonth() + 1)));
        return this;
    };

    AdvDate.firstOfNextMonth = function(date) {
        var thisMonth = date.getMonth();
        var thisYear  = date.getFullYear();
        var first     = 1;
        var MonthToUse;
        var YearToUse;
        //Need to deal with year change
        if (thisMonth == 11) { //December
            MonthToUse = 0; //January
            YearToUse = thisYear + 1;
        } else {
            MonthToUse = thisMonth + 1;
            YearToUse = thisYear;
        }

        return new AdvDate(YearToUse, MonthToUse, first);
    };

    return AdvDate;

})();



if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = AdvDate;
    }
    exports.AdvDate = AdvDate;
}